class ApplicationModalController {
    static $inject = ['close', 'application'];
    constructor(close, application) {
        this.close = close;
        this.application = application;
    }
}
ApplicationModalController.$inject = ['close', 'application'];
export default ApplicationModalController;
